import { Reference } from '@approvalmax/types';
import { constants, statics } from 'modules/common';
import { memo, useMemo } from 'react';

import CurrencyExchangeRateInput from '../../../../components/CurrencyExchangeRateInput/CurrencyExchangeRateInput';
import { NetSuiteExchangeRateProps } from './NetSuiteExchangeRate.types';

const { netSuiteConstants } = constants;

export const NetSuiteExchangeRate = memo<NetSuiteExchangeRateProps>((props) => {
    const { defaultCurrency, requestCurrency, exchangeRateValue, disabled, onExchangeRateValueChange } = props;

    const requestCurrencyRef = statics.currency.findCurrencyByCode(requestCurrency);
    const defaultCurrencyRef = statics.currency.findCurrencyByCode(defaultCurrency);
    const isExchangeRateInputAvailable =
        defaultCurrencyRef && requestCurrencyRef && defaultCurrencyRef.id !== requestCurrencyRef.id;

    const defaultCurrencyValue = useMemo<Reference | null>(() => {
        if (defaultCurrency) {
            return {
                id: defaultCurrency,
                text: defaultCurrency,
            };
        }

        return null;
    }, [defaultCurrency]);

    const requestCurrencyValue = useMemo<Reference | null>(() => {
        if (requestCurrency) {
            return {
                id: requestCurrency,
                text: requestCurrency,
            };
        }

        return null;
    }, [requestCurrency]);

    if (!isExchangeRateInputAvailable) return null;

    return (
        <CurrencyExchangeRateInput
            selectedCurrency={defaultCurrencyValue}
            defaultCurrency={requestCurrencyValue}
            exchangeRateValue={exchangeRateValue || null}
            onExchangeRateChange={onExchangeRateValueChange}
            disabled={disabled}
            max={netSuiteConstants.exchangeRateMaxValue}
            precision={8}
        />
    );
});

NetSuiteExchangeRate.displayName = 'NetSuiteExchangeRate';
